import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  stationRevenueForecast: [],
  loading: false,
  error: null,
};

const stationRevenueForecastSlice = createSlice({
  name: "stationRevenueForecast",
  initialState,
  reducers: {
    fetchStationRevenueForecastSuccess: (state, action) => {
      state.loading = false;
      state.stationRevenueForecast = action.payload;
    },
    fetchStationRevenueForecastFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchStationRevenueForecastSuccess, fetchStationRevenueForecastFailure } =
  stationRevenueForecastSlice.actions;

export default stationRevenueForecastSlice.reducer;
